<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide'
import Content from '~/components/Common/Content.vue'
import PageHeader from '~/components/Product/LandingPages/PageHeader.vue'
import CardList from '~/components/Product/LandingPages/CardList.vue'
import UspBlock from '~/components/Product/LandingPages/Phengold/UspBlock.vue'
import UspItem from '~/components/Product/LandingPages/UspItem.vue'
import Offer from '~/components/Product/LandingPages/Offer.vue'
import Faqs from '~/components/Product/LandingPages/Faqs.vue'
import Accordion from '~/components/Product/LandingPages/Accordion.vue'

import bottles from '~/public/images/products/phengold/bottles.webp'
import checkmark from '~/public/images/products/phengold/checkmark.svg'
import fileLines from '~/public/images/products/berbaprime/icons/file-lines.svg'
import flagUsa from '~/public/images/products/berbaprime/icons/flag-usa.svg'
import shieldCheck from '~/public/images/products/berbaprime/icons/shield-check.svg'
import truck from '~/public/images/products/berbaprime/icons/truck.svg'

import goalsIconOne from '~/public/images/products/phengold/goals-icon-1.png'
import goalsIconTwo from '~/public/images/products/phengold/goals-icon-2.png'
import goalsIconThree from '~/public/images/products/phengold/goals-icon-3.png'
import goalsIconFour from '~/public/images/products/phengold/goals-icon-4.png'

import testimonialOne from '~/public/images/products/phengold/testimonial-1.webp'
import testimonialTwo from '~/public/images/products/phengold/testimonial-2.webp'
import testimonialThree from '~/public/images/products/phengold/testimonial-3.webp'
import testimonialFour from '~/public/images/products/phengold/testimonial-4.webp'
import testimonialFive from '~/public/images/products/phengold/testimonial-5.jpg'
import testimonialSix from '~/public/images/products/phengold/testimonial-6.jpg'

import proofIconOne from '~/public/images/products/phengold/proof-icon-1.avif'
import proofIconTwo from '~/public/images/products/phengold/proof-icon-2.avif'
import proofIconThree from '~/public/images/products/phengold/proof-icon-3.avif'

import uspOneImage from '~/public/images/products/phengold/usp-1-image.jpg'
import uspOneTestimonial from '~/public/images/products/phengold/usp-1-testimonial.webp'
import uspTwoImage from '~/public/images/products/phengold/usp-2-image.jpg'
import uspTwoTestimonial from '~/public/images/products/phengold/usp-2-testimonial.webp'
import uspThreeImage from '~/public/images/products/phengold/usp-3-image.jpg'
import uspThreeTestimonial from '~/public/images/products/phengold/usp-3-testimonial.webp'
import uspFourImage from '~/public/images/products/phengold/usp-4-image.webp'
import uspFourTestimonial from '~/public/images/products/phengold/usp-4-testimonial.webp'
import uspFiveImage from '~/public/images/products/phengold/usp-5-image.jpg'
import uspFiveTestimonial from '~/public/images/products/phengold/usp-5-testimonial.webp'

import ingredientOne from '~/public/images/products/phengold/ingredient-1.webp'
import ingredientTwo from '~/public/images/products/phengold/ingredient-2.webp'
import ingredientThree from '~/public/images/products/phengold/ingredient-3.avif'
import ingredientFour from '~/public/images/products/phengold/ingredient-4.webp'
import ingredientFive from '~/public/images/products/phengold/ingredient-5.webp'
import ingredientSix from '~/public/images/products/phengold/ingredient-6.webp'
import ingredientSeven from '~/public/images/products/phengold/ingredient-7.webp'
import ingredientEight from '~/public/images/products/phengold/ingredient-8.webp'
import ingredientNine from '~/public/images/products/phengold/ingredient-9.webp'

import infoIconOne from '~/public/images/products/phengold/info-icon-1.jpg'
import infoIconTwo from '~/public/images/products/phengold/info-icon-2.jpg'
import infoIconThree from '~/public/images/products/phengold/info-icon-3.jpg'
import infoIconFour from '~/public/images/products/phengold/info-icon-4.avif'
import infoIconFive from '~/public/images/products/phengold/info-icon-5.jpg'
import infoIconSix from '~/public/images/products/phengold/info-icon-6.avif'
import infoIconSeven from '~/public/images/products/phengold/info-icon-7.jpg'
import infoIconEight from '~/public/images/products/phengold/info-icon-8.avif'

import productImage from '~/public/images/products/phengold/product-image.webp'

import infoImageOne from '~/public/images/products/phengold/info-image-1.avif'
import infoImageTwo from '~/public/images/products/phengold/info-image-2.avif'
import infoImageThree from '~/public/images/products/phengold/info-image-3.avif'

import articleOne from '~/public/images/products/phengold/phengold-vs-phenq.jpg'
import articleTwo from '~/public/images/products/phengold/phengold-vs-phen375.jpg'
import articleThree from '~/public/images/products/phengold/phengold-vs-leanbean.avif'

import ingredientList from '~/public/images/products/phengold/ingredient-list.webp'

const video = ref(null)
const showVideo = ref(false)

const startVideo = () => {
	video.value.play()
	showVideo.value = true
}
</script>

<template>
	<Content>
		<PageHeader
			:items="[
				'Multi-action formula enhances your body\'s natural fat-burning abilities',
				'Burns fat, reduces cravings and boosts metabolism, mood and energy',
				'Clinically proven ingredients and backed by our money back guarantee',
			]"
			:item-icon="checkmark"
			item-size="m"
			button-text="Order Now"
			button-link="#checkout"
			:main-image="bottles"
			text-color="text-black"
			background="#ffffff"
			:icons="[
				{
					title: 'Free Shipping Worldwide',
					icon: truck,
				},
				{
					title: 'Secure Checkout',
					icon: shieldCheck,
				},
				{
					title: 'Made in the USA',
					icon: flagUsa,
				},
				{
					title: 'FDA Registered Facilities',
					icon: fileLines,
				},
			]">
			<template #header>
				<h1 class="text-2xl font-medium mb-4 md:text-5xl text-[#173f89] text-center md:text-start">
					PhenGold speeds up weight loss naturally, multi-action metabolism booster 🔥
				</h1>
			</template>
		</PageHeader>

		<div class="bg-[#f2f4f8]">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8">
				<h2 class="text-center text-highlight">Real, lasting weight loss starts here</h2>
				<p class="text-center text-color">Combined with a healthy lifestyle, PhenGold can help you finally achieve your weight loss goals.</p>

				<div class="grid md:grid-cols-4 gap-8">
					<div
						v-for="item in [
							{
								image: goalsIconOne,
								text: 'Jumpstart weight loss',
							},
							{
								image: goalsIconTwo,
								text: 'Break frustrating plateaus',
							},
							{
								image: goalsIconThree,
								text: 'Hit your target weight',
							},
							{
								image: goalsIconFour,
								text: 'Look and feel your best',
							},
						]"
						class=""
					>
						<div class="flex flex-col items-center justify-center mt-8">
							<img :src="item.image" alt="" class="w-20 h-20 mb-4" />
							<p class="text-highlight text-center text-sm font-semibold">{{ item.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<CardList
			:items="[
				{
					starsImage: null,
					image: testimonialOne,
					highlight: 'I dropped 9 pounds',
					quote: 'Within four weeks of adding PhenGold into my routine, I dropped 9 pounds and lost 2 inches around my waist! Seeing the weight dropping off gave me the boost I needed to keep going. And for the first time in months, I can feel my confidence. starting to return.',
					information: 'Laura, New York, US',
				},
				{
					starsImage: null,
					image: testimonialTwo,
					highlight: 'I was able to lose 21 pounds!',
					quote: 'After taking PhenGold for 3 weeks I felt I had. more energy and better focus. Over a period. of four months I was able to lose 21 pounds! I now feel confident enough to join a gym and I\'ll be using PhenGold as a way to control my snacking and maintain my weight.',
					information: 'Kristina, London, UK',
				},
				{
					starsImage: null,
					image: testimonialThree,
					highlight: 'I lost 19 pounds in four weeks',
					quote: 'Phengold helped with curbing my appetite big time. I found that I didn\'t snack between meals at all. H lost 19 pounds in four weeks with taking phengold along with healthy eating and regular exercise. ',
					information: 'Julie, Ridgeville, US',
				},
				{
					starsImage: null,
					image: testimonialFour,
					highlight: 'A great product so far!',
					quote: 'I have immensely enjoyed the success since using this product. My cravings have been tamed and I\'ve enjoyed the increased levels of energy, competencies, and endurance. A great product so far!',
					information: 'Derek, Downingtown, US',
				},
				{
					starsImage: null,
					image: testimonialFive,
					highlight: 'Exactly what I was looking for',
					quote: 'I could see the difference in my weight maintenance as well as fat in the lower belly area after consuming the supplement for a week. ',
					information: 'Dhanushka',
				},
				{
					starsImage: null,
					image: testimonialSix,
					highlight: 'Improved my confidence',
					quote: `In just 6 months I lost almost 60 pounds!!!<br /><br />I love this supplement and the way it has improved my confidence. Thank you!!!`,
					information: 'Meghan, US',
				},
				{
					starsImage: null,
					image: null,
					highlight: 'Thank you PhenGold for keeping me in shape',
					quote: `I love the energy it gives me especially when I go to the gym and at work, it keeps me up all night coz I work graveyard shift. I don\'t have to worry too much on dieting coz taking it provides you with &quot;muscle memory&quot; of when to stop eating or not.`,
					information: 'Melony, Las Vegas, US',
				},
				{
					starsImage: null,
					image: null,
					highlight: 'Difference in my cravings and appetite',
					quote: 'I have not yet finished my first month but have already noticed a difference in my cravings and appetite. I feel great and am beginning to. notice a change in my body composition - and it\'s not been even a month yet!',
					information: 'Anthony, Westminster, US',
				},
			]"
			:slider="true"
			:per-page="3"
			background="bg-white">
			<template #header>
				<div class="uppercase text-center">Success Stories</div>
				<h2 class="text-3xl text-center text-highlight mt-2">
					Thousands of dieters are enjoying<br>
					weight loss success with PhenGold
				</h2>
			</template>

			<template #slides="{ items }">
				<SplideSlide
					v-for="(item, index) in items"
					:key="index"
					class="flex flex-col gap-4 bg-[#f2f4f8] p-4 rounded-2xl h-fit">
					<img v-if="item.starsImage" class="" :src="item.starsImage" />
					<img v-if="item.image" class="rounded-xl" :src="item.image" />
					<div class="flex flex-col items-center">
						<p v-if="item.highlight" class="text-highlight font-semibold mb-2">"{{ item.highlight }}"</p>
						<p v-if="item.quote" class="text-color !text-sm mb-2" v-html="item.quote"></p>
						<p v-if="item.information" class="text-color font-bold !text-sm mb-0">{{ item.information }}</p>
						<p class="flex items-center gap-2 !text-xs text-white bg-green-500 px-2 py-1 rounded-md text-start mt-4 mb-0">
							<Icon
								name="ph:check"
								class="text-white h-4 w-4"
							/>
							Verified customer
						</p>
					</div>
				</SplideSlide>
			</template>

			<template #footer>
				<a
					class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center w-fit mt-8 mx-auto"
					href="#checkout">
					Order Now
					<Icon name="ph:caret-right-bold" />
				</a>

				<p class="!text-sm mt-4 text-color">Free shipping and 100% secure checkout</p>
			</template>
		</CardList>

		<div class="bg-[#f2f4f8]">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<div class="grid md:grid-cols-2 gap-4">
					<div class="">
						<div class="uppercase">Proven Weight Loss</div>
						<h2 class="text-3xl text-highlight mt-2 mb-8 text-balance">
							Max strength, multi-action formula made with clinically proven ingredients helps you burn fat and. keep the weight off for good.
						</h2>

						<div class="w-24 h-1 bg-[linear-gradient(90deg,#17408a_0%,#17408a_50%,#bc8966_50%,#bc8966_100%)] my-4"></div>

						<p class="text-color !text-base md:!text-lg pt-0">
							By increasing your metabolism, activating powerful fat-burning hormones and helping control hunger and cravings, PhenGold can help you lose weight more. quickly and more easily than through dieting and. exercise alone.<br /><br />
							PhenGold further supports your weight loss efforts by boosting your energy and improving your mood,. helping make dieting a more pleasant, positive. experience.
						</p>
					</div>

					<div class="flex flex-col gap-4">
						<div
							v-for="item in [
								{
									image: proofIconOne,
									text: 'Clinically Proven Ingredients',
								},
								{
									image: proofIconTwo,
									text: 'Max Strength Formula',
								},
								{
									image: proofIconThree,
									text: 'No Prescription Required',
								}
							]"
							class="flex items-center gap-8"
						>
							<img :src="item.image" alt="" class="w-32 h-32 mb-4" />
							<p class="text-color !text-xl">{{ item.text }}</p>
						</div>
					</div>
				</div>
				<p class="text-color !text-base md:!text-lg pt-8">
					With continued use, PhenGold can help you maintain your weight once you've reached your body goals.
				</p>
			</div>
		</div>

		<UspBlock
			v-for="(item, index) in [
				{
					title: '1. Improves your body\'s ability to burn fat faster and more effectively',
					text: `PhenGold &quot;switches on&quot; specific fat-burning hormones that tell your body to break down and burn stored fat. By activating hormones known to have a direct effect on fat burning, PhenGold can help you burn off even the most stubborn fat for good`,
					image: uspOneImage,
					testimonial: {
						image: uspOneTestimonial,
						text: 'Within four weeks I dropped 9 pounds and lost 2 inches around my waist',
						information: 'Kate, US',
					},
					slides: [
						'Caffeine, L-tyrosine, rhodiola, green tea and the capsaicin in cayenne pepper all help your body burn fat faster by increasing levels of fat-burning hormones HSL (hormone-sensitive lipase), epinephrine, norepinephrine and adiponectin[1].',
						'Green tea, green coffee, caffeine and L-theanine can help shrink fat cells by significantly reducing triglycerides[2], a type of fat stored inside your fat cells and the main form of fat in your body.',
						'Capsaicin in cayenne pepper may help reduce stubborn belly fat by boosting levels of a fat-burning enzyme called HSL (hormone-sensitive lipase) specifically in your abdominal area[3].',
					],
				},
				{
					title: '2. Boosts your metabolism, helping you burn more calories and more fat round-the-clock',
					text: 'The faster your metabolism, the faster your body burns fat. PhenGold stimulates your body\'s natural metabolic rate and speeds up the rate at which calories and stored fat are converted into energy. Which means you\'ll naturally burn more calories and more unwanted fat every day. Even while you\'re doing nothing..',
					image: uspTwoImage,
					testimonial: {
						image: uspTwoTestimonial,
						text: 'Seeing the weight dropping off. gave me the boost I needed to keep going',
						information: 'Dave, US',
					},
					slides: [
						'Caffeine has been found in studies to increase metabolism by up to 11% and boost fat burning by as much as 29% [4].',
						'Capsaicinoids in cayenne pepper could help you burn as many as 50 extra calories per day[5]. Studies have also found that green tea extract could help you burn up to 17% more fat, especially if taken before exercise[6].',
						'B vitamins provide essential metabolism support[7] by helping convert carbohydrates, fats and proteins into energy instead of letting them turn to fat. Vitamin B6 also helps increase production of L-carnitine, an amino acid that helps your body burn fat.',
						'Caffeine, green coffee, green tea and capsaicin increase levels of adiponectin, a fat-burning hormone which boosts your metabolism  and improves your body\'s ability to use carbohydrates for energy instead of fat-storage[8].',
					],
				},
				{
					title: '3. Curbs cravings and hunger to. help you stop snacking and stay in control of your eating.',
					text: 'By acting as a natural appetite suppressant, PhenGold can help you feel fuller and help reduce food cravings in. between meals. Making it easier for you to avoid overeating, reduce your calorie intake and stay on track with your healthy diet',
					image: uspThreeImage,
					testimonial: {
						image: uspThreeTestimonial,
						text: 'I struggled with eating fewer. calories which inevitably led to. snacking. That\'s where PhenCold made the biggest. difference',
						information: 'Jane, US',
					},
					slides: [
						'Capsaicin and caffeine are natural hunger suppressants. Studies have found that they can help reduce cravings and hunger, decrease your appetite and help you feel more full when you eat[9].',
						'B vitamins could help curb carb and sugar cravings by helping your body use carbohydrates more effectively. Which means you won’t feel the need to eat more than you need.',
						'B vitamins can help prevent stress-related food cravings because they play a vital role in helping your body manage stress - a key cause of cravings and increased appetite[10].',
						'As natural mood boosters, L-theanine, L-tyrosine, B vitamins and DMAE may help you gain control over emotional eating by reducing the feelings of stress, anxiety and depression that can trigger the impulse to turn to food for comfort[11].',
					],
				},
				{
					title: '4. Increases your energy and. focus, giving you the power to tackle every day',
					text: 'Dieting - and daily life - can leave you feeling drained and low on energy. Whether you need extra power for your morning workout, a midday lift during a long. workday or a boost tackling the nightly bedtime routine with your little ones, PhenGold will give you the physical and mental energy to get through any day',
					image: uspFourImage,
					testimonial: {
						image: uspFourTestimonial,
						text: 'I felt I had more energy and better focus. For me, that was. what I needed to keep going.',
						information: 'Tiffany, US',
					},
					slides: [
						'Caffeine, green coffee and green tea help you feel more energized, awake and focused by blocking the release of adenosine, a chemical that makes you feel tired[12].',
						'L-theanine enhances the energizing effects of caffeine while counteracting it’s drawbacks, helping you feel relaxed, less tired and more focused and alert.',
						'Vitamins B3, B6 and B12 provide essential energy support by converting food into fuel, which helps maintain your energy levels and reduce tiredness and fatigue[13].',
						'Rhodiola rosea can reduce feelings of weakness and fatigue and help improve your focus and concentration[14].',
					],
				},
				{
					title: '5. Enhances your mood, helping you stay motivated and focused on your goals',
					text: 'Dieting doesn\'t have to be depressing. PhenGold is packed with proven mood- boosting ingredients to help keep you. feeling bright and positive each and every day. Making it easier to stay motivated. stick to your plan and achieve your goals.',
					image: uspFiveImage,
					testimonial: {
						image: uspFiveTestimonial,
						text: 'For the first time in months, I can feel my confidence starting to return..',
						information: 'Anusha, US.',
					},
					slides: [
						'L-tyrosine, L-theanine and caffeine boost your mood and promote feelings of positivity and happiness by increasing levels of dopamine, serotonin and norepinephrine, otherwise known as “happy hormones”[15].',
						'B vitamins help brighten your mood and fend off the blues by converting amino acids into feel-good chemicals like serotonin and norepinephrine.',
						'DMAE enhances your mood and motivation and reduces feelings of depression, anxiety and irritability[16].',
					],
				},
			]"
			:title="item.title"
			:text="item.text"
			:image="item.image"
			:testimonial="item.testimonial"
			:slides="item.slides"
			:background="index % 2 !== 0 ? 'bg-[#f2f4f8]' : 'bg-white'"
			:slide-background="index % 2 === 0 ? 'bg-[#f2f4f8]' : 'bg-white'"
		/>

		<div class="bg-[#173f88] mt-4">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-12 grid md:grid-cols-2 gap-8 text-white">
				<div>
					<h2 class="text-inherit text-center text-3xl">
						Packed with scientifically-backed ingredients, PhenGold can help you finally achieve your health and weight loss goals
					</h2>

					<a
						class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center w-fit mt-8 mx-auto"
						href="#checkout">
						Order Now
						<Icon name="ph:caret-right-bold" />
					</a>

					<p class="text-center text-gray-400 mt-4">
						FDA registered facilities and<br />
						100% secure checkout
					</p>
				</div>

				<div class="md:relative">
					<img
						class="md:absolute w-full md:top-1/2 md:-translate-y-1/2 z-10"
						:src="productImage"
					/>
				</div>
			</div>
		</div>

		<div class="bg-white">
			<div class="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<p class="!text-base md:!text-xl text-center text-color uppercase mb-0">Quality assured</p>
				<h2 class="text-3xl text-center text-highlight my-0">
					Scientifically formulated with safe natural clinically proven ingredients
				</h2>
				<div class="w-24 h-1 bg-[linear-gradient(90deg,#17408a_0%,#17408a_50%,#bc8966_50%,#bc8966_100%)] my-4 mx-auto"></div>
				<p class="text-color !text-base md:!text-lg pt-0 mt-8">
					Formulated by experts, PhenGold has been scrupulously designed and developed using carefully selected, exhaustively researched. clinically proven ingredients to create one of the most powerful and effective weight loss supplements available without a prescription.<br /><br />
					PhenGold is manufactured in an FDA registered, GMP certified facility to the highest production standards under strict implementation of quality control and quality assurance regulations. Which means you can purchase PhenGold with confidence, knowing you are getting a guaranteed safe, quality weight loss supplement you can trust.<br /><br />
					Each serving of PhenGold is packed with maximum strength amounts of the following ingredients that have been clinically proven to help you lose weight:
				</p>
			</div>
			<div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 md:pb-16">
				<div class="grid md:grid-cols-3 gap-8">
					<div
						v-for="item in [
							{
								image: ingredientOne,
								title: '500mg Green Tea',
								text: 'Burns fat, boosts metabolism',
							},
							{
								image: ingredientTwo,
								title: '100mg Green Coffee',
								text: 'Burns fat, boosts metabolism, increases energy',
							},
							{
								image: ingredientThree,
								title: '250mg L-Theanine',
								text: 'Boosts metabolism, improves mood and focus',
							},
							{
								image: ingredientFour,
								title: '350mg L-Tyrosine',
								text: 'Burns fat, improves mood and focus',
							},
							{
								image: ingredientFive,
								title: '250mg Rhodiola Rosea',
								text: 'Burns fat, increases energy',
							},
							{
								image: ingredientSix,
								title: '200mg Cayenne Pepper',
								text: 'Burns fat, boosts metabolism. suppresses appetite',
							},
							{
								image: ingredientSeven,
								title: '225mg Caffeine',
								text: 'Burns fat, boosts metabolism, suppresses appetite increases energy and focus',
							},
							{
								image: ingredientEight,
								title: '150mg DMAE',
								text: 'Improves mood and motivation',
							},
							{
								image: ingredientNine,
								title: 'Vitamins B3, B6, B12',
								text: 'Boosts metabolism, controls cravings, increases energy, improves mood',
							},
						]"
						class="flex flex-col">
						<img :src="item.image" alt="" class="w-20 h-20 mb-4" />
						<p class="!text-base md:!text-xl text-highlight my-0 mb-1 font-medium">
							{{ item.title }}
						</p>
						<p class="text-color !text-base md:!text-lg my-0">
							{{ item.text }}
						</p>
					</div>
				</div>
			</div>
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 md:pb-16">
				<hr class="mb-12">
				<div class="grid grid-cols-2 md:grid-cols-4 gap-8">
					<div
						v-for="item in [
							{
								image: infoIconOne,
								text: '100% safe<br />and natural',
							},
							{
								image: infoIconTwo,
								text: 'No side<br />effects',
							},
							{
								image: infoIconThree,
								text: 'Manufactured<br />in the USA'
							},
							{
								image: infoIconFour,
								text: 'FD registered<br />GMP certified',
							},
							{
								image: infoIconFive,
								text: 'Vegetarion and<br />vegan friendly',
							},
							{
								image: infoIconSix,
								text: 'Soy, gluten, and<br />dairy free',
							},
							{
								image: infoIconSeven,
								text: 'Non-GMO<br />ingredients',
							},
							{
								image: infoIconEight,
								text: 'No fillers<br />nothing artificial',
							},
						]"
						class="flex flex-col items-center">
						<img :src="item.image" alt="" class="w-20 h-20 mb-4" />
						<p class="!text-base text-center text-highlight my-0 mb-1 font-bold uppercase" v-html="item.text"></p>
					</div>
				</div>
				<a
					class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center w-fit mt-8 mx-auto"
					href="#checkout">
					Order Now
					<Icon name="ph:caret-right-bold" />
				</a>

				<p class="text-center text-gray-600 mt-4">
					Guaranteed safe and effective
				</p>
			</div>
		</div>

		<div class="bg-[#fbf8f6]">
			<div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<p class="!text-base md:!text-xl text-center text-color uppercase mb-2">A new you</p>
				<h2 class="text-3xl text-center text-[#bb8967] my-0">
					Put your weight loss worries behind you with PhenGold
				</h2>

				<ul class="flex flex-col gap-2 m-0 mt-4 p-0">
					<li
						v-for="item in [
							'No more hiding your body underneath baggy, shapeless clothes',
							'Get dressed every day in clothes that you love and feel good in',
							'Enjoy shopping, knowing you can buy what you want, not whatever fits',
							'Look forward to holidays and special events, confident you\'ll always look your best',
							'Celebrate the reflection you see every time you look in the mirror',
							'Love your body again and feel happy, healthy and confident every day',
						]"
						class="flex gap-2 items-center list-none"
					>
						<Icon name="ph:check-circle-fill" class="text-[#bb8967] h-8 w-8" />

						<p class="text-color !text-base md:!text-xl my-0 flex-1">
							{{ item }}
						</p>
					</li>
				</ul>

				<a
					class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center w-fit mt-8 mx-auto"
					href="#checkout">
					Order Now
					<Icon name="ph:caret-right-bold" />
				</a>

				<p class="text-center text-gray-600 mt-4">
					Free shipping and 100% secure checkout
				</p>
			</div>
		</div>

		<div class="bg-white">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
				<p class="!text-base md:!text-xl text-center text-color uppercase mb-2">Purchase risk free</p>
				<h2 class="text-3xl text-center text-highlight my-0">
					100-day, guaranteed weight loss money back guarantee
				</h2>

				<div class="grid md:grid-cols-2 gap-8 mt-12">
					<img class="mx-auto" src="~/public/images/products/phengold/money-back-guarantee.webp" />

					<div class="flex flex-col justify-between flex-1">
						<p class="text-color !text-base md:!text-xl pt-0">
							But if, after giving it an honest try for at least 50 days,. you don't believe PhenGold is supporting your weight. loss efforts, simply email us within 50-100 days of. receiving your order and we'll happily refund your. money, excluding a $15 fixed fee to cover shipping and admin costs*.
						</p>

						<p class="!text-sm text-gray-400">
							*Terms and conditions apply. Guarantee applies to purchases of over one. month's supply and only on first purchase. Click here to read the full terms of our refund policy.
						</p>
					</div>
				</div>

				<div class="grid md:grid-cols-3 gap-8 mt-8 md:mt-20">
					<div
						v-for="item in [
							{
								image: infoImageOne,
								text: 'Scientifically formulated with clinically backed ingredients',
							},
							{
								image: infoImageTwo,
								text: 'Max strength formula for fast. effective weight loss',
							},
							{
								image: infoImageThree,
								text: 'Powerful fat burning without a prescription',
							},
						]"
						class="flex flex-col items-center">
						<img :src="item.image" alt="" class="w-48 h-48 mb-4" />
						<p class="!text-base md:!text-xl text-center text-highlight my-0 mb-1 font-medium text-balance" v-html="item.text"></p>
					</div>
				</div>
			</div>
		</div>

		<div class="bg-[#173f88]">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 md:pt-16">
				<h2 class="text-3xl text-center text-white my-0">
					Fed up with weight loss supplements that don't work?<br />
					It's time to try PhenGold.
				</h2>

				<p class="text-center text-white !text-base md:!text-lg pt-0 mt-8 text-balance">
					Made with clinically proven ingredients and backed by our money back guarantee*.  Get FREE shipping and save 10% instantly when you use the code "SAVE10" at the checkout now
				</p>

				<div class="flex gap-8 justify-center mt-12 flex-wrap">
					<UspItem
						v-for="(item, index) in [
							{
								icon: 'ph:shield-check',
								text: 'Secure Checkout',
							},
							{
								icon: 'ph:money',
								text: 'One Time Payment Only',
							},
							{
								icon: 'ph:globe-simple',
								text: 'Worldwide Shipping',
							},
						]"
						:key="index"
						:icon="item.icon"
						:text="item.text"
						text-color="text-white"
					/>
				</div>
			</div>
		</div>

		<Offer
			product-title="PHENGOLD - METABOLISM BOOSTER"
			rated-text="Rated 4.6/5 by thousands of slimmer customers"
			product-description="PhenGold speeds up weight loss naturally, helping you lose weight quickly and effectively."
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ0NjMwMTgwODI2MTMsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA3MDk0NzYxODg0NjksICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA5NzE1NTQ4MTkwOX1dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/44463018082613:1?channel=buy_button"
			:subscribe-price="47.99"
			:discounted-price="59.99"
			:original-price="69.99"
			:product-image="productImage"
			background="bg-[#173f88]"
			text-color="#ffffff" />

		<div class="bg-[#f0f1f5]">
			<div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-20">
				<div class="border-red-600 bg-white border-4 border-solid rounded-2xl p-4 md:py-12 md:px-20">
					<img v-show="!showVideo" class="w-full" src="~/public/images/products/phengold/video-thumbnail.webp" @click="startVideo" />

					<video
						v-show="showVideo"
						ref="video"
						class="w-full"
						controls
						playsinline
						src="https://cdn.shopify.com/videos/c/o/v/1c90db35e57445c3843be2b210c30b7c.mp4"
					/>
				</div>
			</div>
		</div>

		<Faqs background="#ffffff">
			<template #header>
				<h2 class="text-3xl text-center text-highlight my-0">
					Frequently Asked Questions
				</h2>
			</template>

			<template #paragraph>
				<p class="text-start text-color !text-base md:!text-lg pt-0 mt-8">
					You'll find the answers to our most frequently asked questions below. If your question hasn't been covered or if you'd like further information about any of the topics covered below, please feel free to get in touch. Our Customer Care team is available 24/7 and will be delighted to talk to you about PhenGold. Click here to contact us.
				</p>
			</template>

			<template #items>
				<Accordion
					v-for="(item, index) in [
						{
							question: 'Where can I buy PhenGold?',
							answer: `PhenGold is available to purchase from the website HealthNutrition.com and is also available on <a href='https://www.amazon.com/stores/PhenGold/page/9BDEC9AD-188C-4AAB-8FB2-C07A2C33B11B' target='_blank'>Amazon.com</a>, <a href='https://www.walmart.com/ip/PhenGold-Diet-Pills-Fat-Burner-Appetite-Suppressant-90-Max-Strength-Dietary-Supplement-Weight-Loss-Capsules/5052512024' target='_blank'>Walmart.com</a> and other select suppliers. &nbsp;Currently PhenGold is not available at GNC or other local retailers. We recommend purchasing directly at <a href='https://healthnutrition.com/products/phengold#i2l459fefd610' target='_blank'>HealthNutrition.com</a> to avoid fake or counterfeit products.`,
						},
						{
							question: 'How do I take PhenGold?',
							answer: `Just take three PhenGold capsules 20 minutes before your breakfast every morning, ideally before a workout.`,
						},
						{
							question: 'How does PhenGold work?',
							answer: `Yes, PhenGold works. Every ingredient has been exhaustively researched and chosen specifically for its proven ability to help you lose weight. Extensive clinical studies have been carried out on the ingredients contained in PhenGold verifying their weight loss benefits. Pair with a calorie-controlled diet and regular exercise, to supercharge your weight loss results.`,
						},
						{
							question: 'How long does PhenGold take to work?',
							answer: `
							If you follow a healthy diet, exercise regularly and take PhenGold as directed, you could expect to see results within just a few weeks. Most of our customers enjoy visible weight loss within the first few months. Individual results will vary.<br /><br />
							No weight loss supplement is a quick fix. The longer you supplement with PhenGold the better results you can expect. You will lose more weight when you combine PhenGold with healthy lifestyle changes like eating a balanced, nutritious diet and getting regular physical activity.
							`,
						},
						{
							question: 'How many servings does PhenGold contain?',
							answer: `PhenGold contains 30 servings (90 capsules).`,
						},
						{
							question: 'Does PhenGold come with a guarantee?',
							answer: `We offer an industry-leading 100-day money-back guarantee. If, after using PhenGold as directed alongside a suitable diet and exercise program for at least 50 days, you don’t believe PhenGold is supporting your weight loss efforts, simply email us within 50-100 days of receiving your order and we will happily refund your money, excluding a $15 fixed fee to cover shipping and admin costs. Terms and conditions apply. <a href='https://healthnutrition.com/policies/refund-policy' target='_blank'>Please click here</a> to read the full terms of our refund policy.`,
						},
						{
							question: 'Does PhenGold have any side effects?',
							answer: `
								PhenGold is completely safe. That’s because we use only 100% natural ingredients that have been thoroughly researched, tested and proven to be safe and effective.<br /><br />
								PhenGold does contain 225mg of caffeine, 500mg of green tea and 100mg of green coffee per daily dose. So if you’re sensitive to caffeine or if you do experience any adverse effects from these stimulants, we recommend you limit or avoid your use of any other caffeinated products while you’re taking PhenGold.<br /><br />
								A small number of customers have reported feelings of dizziness, shakiness and/or headaches when using PhenGold. We have found that ensuring PhenGold is taken before food as directed and decreasing or avoiding use of other caffeinated products while using PhenGold resolves these symptoms.<br /><br />
								PhenGold is not recommended if you are pregnant or breastfeeding. If you have any existing health issues or you are currently taking any medication, you should consult your healthcare professional before taking PhenGold to ensure it is suitable for you. Otherwise, PhenGold is safe for healthy adults when used as directed.
							`,
						},
						{
							question: 'Is PhenGold FDA approved?',
							answer: `PhenGold is manufactured in FDA registered, Good Manufacturing Practice (GMP) certified facilities in the USA. This means that PhenGold is produced and controlled to international quality standards throughout every step of the manufacturing process. So you can be sure that when you order PhenGold, you are getting a safe supplement of the highest quality.`,
						},
						{
							question: 'What is the exact ingredient list for PhenGold?',
							answer: `
								We are entirely open and transparent about exactly what goes into PhenGold and we fully disclose every ingredient, including their exact amounts. There are no hidden ingredients, no “secret” ingredients and we do not use any “proprietary” blends.
								<img src='${ingredientList}' />
							`,
						},
						{
							question: 'Does PhenGold ship worldwide?',
							answer: `We currently ship to USA, UK and Canada.`,
						},
						{
							question: 'When will my PhenGold order arrive?',
							answer: `
								Delivery times depend on your location. Assuming you place an order before 13:00 Monday-Friday, and your products are in stock, you can expect the following delivery times:
								<br /><br />
								USA: 3-7 working days<br />
								UK: 3-7 working days<br />
								Canada: 5-10 working days
							`,
						},
					]"
					:heading="item.question"
					heading-color="text-highlight"
					:text="item.answer"
					background="#ffffff"
					class="border rounded-lg"
				>

				</Accordion>
			</template>
		</Faqs>

		<CardList
			background="bg-[#f2f4f7]"
			:items="[
				{
					image: articleOne,
					title: 'PhenGold vs PhenQ: Which Is Best?',
					text: 'You can seriously speed up your weight loss and muscle gain with the right supplement. But with so many fat burners and weight loss pills',
					link: '',
				},
				{
					image: articleTwo,
					title: 'PhenGold vs Phen375: Which Weight Loss Supplement Is Best?',
					text: 'To lose weight and get in shape takes time. Let\'s face it, weight loss and muscle gain just aren\'t achieved overnight. But you can give',
					link: '',
				},
				{
					image: articleThree,
					title: 'PhenGold vs Leanbean: Which Weight. Loss Supplement Is Right For You?',
					text: 'If you\'ve tried to lose weight before, you. know how difficult weight loss can be.. You have to stick to your diet and resist those',
					link: '',
				},
			]">
			<template #header>
				<p class="!text-base md:!text-xl text-center text-color uppercase mb-2">No comparison</p>
				<h2 class="text-3xl text-center text-highlight my-0 text-balance">
					Find out what makes PhenGold one of the leading weight loss supplements on the market.
				</h2>
			</template>

			<template #paragraph>
				<p class="text-start text-color !text-base md:!text-lg pt-0 mt-8">
					We want you to feel as confident as us that when you purchase. PhenGold, you're getting one of the most powerful, effective and. scientifically proven weight loss supplements on the market. So take a look at the articles below to see for yourself how PhenGold. compares to similar supplements
				</p>
			</template>

			<template #slides="{ items }">
				<a
					v-for="item in items"
					:href="item.link"
					class="no-underline"
				>
					<img :src="item.image" alt="" class="w-full rounded-2xl mb-4" />
					<p class="text-start !text-base md:!text-xl text-highlight my-0 mb-2 font-semibold text-balance">
						{{ item.title }}
					</p>

					<p class="text-start text-color !text-base md:!text-lg my-0 mb-2">
						{{ item.text }}
					</p>

					<p class="text-start text-color !text-base md:!text-lg underline">Read more...</p>
				</a>
			</template>
		</CardList>

		<div class="bg-white">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:pt-16">
				<h2 class="text-3xl text-center text-highlight my-0">
					PhenGold. The gold standard of <br />weight loss supplements.
				</h2>

				<p class="text-center text-color !text-base md:!text-lg pt-0 mt-8">
					Scientifically-backed weight loss. Guaranteed
				</p>

				<a
					class="btn btn-primary btn-large !text-base !tracking-normal flex items-center justify-center w-fit mt-8 mx-auto"
					href="#checkout">
					Order Now
					<Icon name="ph:caret-right-bold" />
				</a>
			</div>
		</div>

		<Faqs background="#ffffff">
			<template #header>
				<h2 class="text-3xl text-center text-highlight my-0">
					Clinical References
				</h2>
			</template>

			<template #items>
				<Accordion
					v-for="(item, index) in [
						{
							heading: '1. Caffeine, L-tyrosine, rhodiola, green tea and capsaicin increase HSL (hormone-sensitive lipase), epinephrine, norepinephrine and adiponectin..',
							text: `<ul><li>Capsaicin significantly up-regulated levels of genes involved in lipid catabolism such as hormone sensitive lipase (HSL):<br>Lee MS, Kim CT, Kim IH, Kim Y. Effects of capsaicin on lipid catabolism in 3T3-L1 adipocytes. Phytother Res. 2011 Jun;25(6):935-9. doi: 10.1002/ptr.3339. Epub 2010 Nov 17. <a href='https://pubmed.ncbi.nlm.nih.gov/21626599/'>PMID: 21626599</a></li><li>Capsaicin treatment boosted visceral adipose expression of hormone-sensitive lipase:<br>Kang JH, Kim CS, Han IS, et al. Capsaicin, a spicy component of hot peppers, modulates adipokine gene expression and protein release from obese-mouse adipose tissues and isolated adipocytes, and suppresses the inflammatory responses of adipose tissue macrophages. FEBS Lett 2007;581:4389–96. doi:<a href='https://openheart.bmj.com/content/2/1/e000262#xref-ref-54-1'>10.1016/j.febslet.2007.07.082</a></li><li>Topical application of capsaicin increased expression of adiponectin, significantly reduced visceral fat and markedly reduced the size of fat cells in mice:<br>Lee GR, Shin MK, Yoon DJ, Kim AR, Yu R, Park NH, Han IS. Topical application of capsaicin reduces visceral adipose fat by affecting adipokine levels in high-fat diet-induced obese mice. Obesity (Silver Spring). 2013 Jan;21(1):115-22. doi: 10.1002/oby.20246. <a href='https://pubmed.ncbi.nlm.nih.gov/23505175/'>PMID: 23505175</a></li><li>Tyrosine is the precursor of epinephrine:<br>National Library of Medicine, Compound Summary: <a href='https://pubchem.ncbi.nlm.nih.gov/compound/L-tyrosine'>Tyrosine<strong>&nbsp;</strong></a></li><li>Rhodiola rosea stimulates norepinephrine activity:<br>American Botanical Council, Issue: 56, Page: 40-52,&nbsp; <a href='http://cms.herbalgram.org/herbalgram/issue56/article2333.html'>Rhodiola rosea: A Phytomedicinal Overview</a><strong>&nbsp;</strong></li><li>Caffeine Increases blood levels of epinephrine and norepinephrine:&nbsp;<br>Keijzers GB, De Galan BE, Tack CJ, Smits P. Caffeine can decrease insulin sensitivity in humans. Diabetes Care. 2002 Feb;25(2):364-9. doi: 10.2337/diacare.25.2.364. <a href='https://pubmed.ncbi.nlm.nih.gov/11815511/'>PMID: 11815511</a></li><li>Capsaicin stimulates the release of adrenaline (epinephrine):<br>Tremblay A, Arguin H, Panahi S. Capsaicinoids: a spicy solution to the management of obesity? Int J Obes (Lond). 2016 Aug;40(8):1198-204. doi: 10.1038/ijo.2015.253. Epub 2015 Dec 21. <a href='https://pubmed.ncbi.nlm.nih.gov/26686003/'>PMID: 26686003</a></li><li>Green tea increases thermogenesis and inhibits an enzyme that degrades norepinephrine:<br>Shixian Q, VanCrey B, Shi J, Kakuda Y, Jiang Y. Green tea extract thermogenesis-induced weight loss by epigallocatechin gallate inhibition of catechol-O-methyltransferase. J Med Food. 2006 Winter;9(4):451-8. doi: 10.1089/jmf.2006.9.451. <a href='https://pubmed.ncbi.nlm.nih.gov/17201629/'>PMID: 17201629</a></li><li>A review of studies suggests a positive association between coffee and adiponectin level and the positive role of green tea in adiponectin concentration:<br>Izadi V, Larijani B, Azadbakht L. Is Coffee and Green Tea Consumption Related to Serum Levels of Adiponectin and Leptin? Int J Prev Med. 2018 Dec 5;9:106. doi: 10.4103/ijpvm.IJPVM_37_14. <a href='https://pubmed.ncbi.nlm.nih.gov/30622689/'>PMID: 30622689</a></li></ul>`,
						},
						{
							heading: '2. Green tea, green coffee, caffeine and L-theanine significantly reduce triglycerides.',
							text: `<ul><li>Both in vitro and animal experiments have shown that green tea catechins can significantly reduce levels of plasma triglycerides: &nbsp;<strong> </strong>Xu, R., Yang, K., Li, S. <i>et al.</i> Effect of green tea consumption on blood lipids: a systematic review and meta-analysis of randomized controlled trials. <i>Nutr J</i> 19, 48 (2020). <a href='https://doi.org/10.1186/s12937-020-00557-5'>https://doi.org/10.1186/s12937-020-00557-5</a>&nbsp;</li><li>Theanine and green tea catechins significantly reduced triglyceride levels in the serum and livers of laboratory mice: Zheng G, Sayama K, Okubo T, Juneja LR, Oguni I. Anti-obesity effects of three major components of green tea, catechins, caffeine and theanine, in mice. In Vivo. 2004 Jan-Feb;18(1):55-62. <a href='https://pubmed.ncbi.nlm.nih.gov/15011752/'>PMID: 15011752</a></li></ul>`,
						},
						{
							heading: '3. Capsaicin boosts HSL (hormone-sensitive lipase) specifically in the abdominal area.',
							text: `Both in vitro and animal experiments have shown that green tea catechins can significantly reduce levels of plasma triglycerides: &nbsp; Xu, R., Yang, K., Li, S. et al. Effect of green tea consumption on blood lipids: a systematic review and meta-analysis of randomized controlled trials. Nutr J 19, 48 (2020). https://doi.org/10.1186/s12937-020-00557-5&nbsp;<br>Theanine and green tea catechins significantly reduced triglyceride levels in the serum and livers of laboratory mice: Zheng G, Sayama K, Okubo T, Juneja LR, Oguni I. Anti-obesity effects of three major components of green tea, catechins, caffeine and theanine, in mice. In Vivo. 2004 Jan-Feb;18(1):55-62. PMID: 15011752`,
						},
						{
							heading: '4. Caffeine can increase metabolism by up to 11% and fat burning by as much as 29%.',
							text: `<ul><li>Caffeine ingestion increased energy expenditure 13% and doubled the turnover of lipids in healthy young men: Acheson KJ, Gremaud G, Meirim I, Montigon F, Krebs Y, Fay LB, Gay LJ, Schneiter P, Schindler C, Tappy L. Metabolic effects of caffeine in humans: lipid oxidation or futile cycling? Am J Clin Nutr. 2004 Jan;79(1):40-6. doi: 10.1093/ajcn/79.1.40. <a href='https://pubmed.ncbi.nlm.nih.gov/14684395/'>PMID: 14684395</a>&nbsp;</li><li>100mg caffeine increased the resting metabolic rate of both lean and postobese human volunteers by 3-4%: Dulloo, A., Geissler, A.C., Horton, T., Collins, A. &amp; Miller, D.S. (1989): ‘Normal caffeine consumption: influence on thermogenesis and daily energy expenditure in lean and postobese human volunteers’. American Journal of Clinical Nutrition, 1989 Jan;49(1):44-50. <a href='https://pubmed.ncbi.nlm.nih.gov/2912010/'>PMID 2912010</a></li><li>Caffeine-induced thermogenesis increased metabolic rate by 4% in healthy male volunteers: Koot P, Deurenberg P. Comparison of changes in energy expenditure and body temperatures after caffeine consumption. Ann Nutr Metab. 1995;39(3):135-42. doi: 10.1159/000177854. <a href='https://pubmed.ncbi.nlm.nih.gov/7486839/'>PMID: 7486839</a></li><li>Coffee-induced thermogenesis increased lipid oxidation by 29 and 10% in lean and obese women, respectively: Bracco D, Ferrarra JM, Arnaud MJ, Jéquier E, Schutz Y. Effects of caffeine on energy metabolism, heart rate, and methylxanthine metabolism in lean and obese women. Am J Physiol. 1995 Oct;269(4 Pt 1):E671-8. doi: 10.1152/ajpendo.1995.269.4.E671. <a href='https://pubmed.ncbi.nlm.nih.gov/7485480/'>PMID: 7485480</a></li></ul>`,
						},
						{
							heading: '5. Capsaicinoids in cayenne pepper could burn as many as 50 extra calories per day.',
							text: `<ul><li>Consumption of capsaicinoids increases energy expenditure by approximately 50 kcal/day:<br>Whiting S, Derbyshire E, Tiwari BK. Capsaicinoids and capsinoids. A potential role for weight management? A systematic review of the evidence. Appetite. 2012 Oct;59(2):341-8. doi: 10.1016/j.appet.2012.05.015. Epub 2012 May 22. <a href='https://pubmed.ncbi.nlm.nih.gov/22634197/'>PMID: 22634197</a></li></ul>`,
						},
						{
							heading: '6. Green tea extract could help burn up to 17% more fat, especially if taken before exercise.',
							text: `<ul><li>Average fat oxidation rates were 17% higher after ingestion of green tea extract than after ingestion of placebo: Venables MC, Hulston CJ, Cox HR, Jeukendrup AE. Green tea extract ingestion, fat oxidation, and glucose tolerance in healthy humans. Am J Clin Nutr. 2008 Mar;87(3):778-84. doi: 10.1093/ajcn/87.3.778. <a href='https://pubmed.ncbi.nlm.nih.gov/18326618/'>PMID: 18326618</a></li></ul>`,
						},
						{
							heading: '7. B vitamins provide essential metabolism support.',
							text: `<ul><li>Niacin (vitamin B3) and contribution to normal energy‐yielding metabolism: European Food Safety Authority, Jul 2015, <a href='https://efsa.onlinelibrary.wiley.com/doi/10.2903/j.efsa.2015.4180'>https://doi.org/10.2903/j.efsa.2015.4180&nbsp;</a>&nbsp;</li><li>Vitamin B6 and contribution to normal energy‐yielding metabolism: European Food Safety Authority, Oct 2010,<a href='https://efsa.onlinelibrary.wiley.com/doi/10.2903/j.efsa.2010.1759'> https://doi.org/10.2903/j.efsa.2010.1759&nbsp;</a></li><li>Vitamin B12 and contribution to normal energy‐yielding metabolism: European Food Safety Authority, Oct 2009, <a href='https://efsa.onlinelibrary.wiley.com/doi/10.2903/j.efsa.2009.1223'>https://doi.org/10.2903/j.efsa.2009.1223</a></li></ul>`,
						},
						{
							heading: '8. Caffeine, green coffee, green tea and capsaicin increase levels of adiponectin, a fat-burning hormone which boosts metabolism and improves the body\'s ability to use carbohydrates for energy.',
							text: `<ul><li>A review of studies suggests a positive association between coffee and adiponectin level and the positive role of green tea in adiponectin concentration: Izadi V, Larijani B, Azadbakht L. Is Coffee and Green Tea Consumption Related to Serum Levels of Adiponectin and Leptin? Int J Prev Med. 2018 Dec 5;9:106. doi: 10.4103/ijpvm.IJPVM_37_14. <a href='https://pubmed.ncbi.nlm.nih.gov/30622689/'>PMID: 30622689</a>&nbsp;</li><li>Topical application of capsaicin increased expression of adiponectin, significantly reduced visceral fat and markedly reduced the size of fat cells in mice: Lee GR, Shin MK, Yoon DJ, Kim AR, Yu R, Park NH, Han IS. Topical application of capsaicin reduces visceral adipose fat by affecting adipokine levels in high-fat diet-induced obese mice. Obesity (Silver Spring). 2013 Jan;21(1):115-22. doi: 10.1002/oby.20246. <a href='https://pubmed.ncbi.nlm.nih.gov/23505175/'>PMID: 23505175</a></li><li>Adiponectin can cause weight loss by raising metabolic rate: Penn Medicine News, Apr 21, 2004, <a href='https://www.pennmedicine.org/news/news-releases/2004/april/fat-cell-hormone-adiponectin'>Fat Cell Hormone Adiponectin Causes Weight Loss Without Affecting Appetite</a></li><li>Adiponectin has been postulated to play an important role in the modulation of glucose and lipid metabolism in insulin-sensitive tissues in both humans and animals: American Diabetes Association, Adiponectin: More Than Just Another Fat Cell Hormone?, Diabetes Care <a href='https://care.diabetesjournals.org/content/26/8/2442'>2003 Aug; 26(8): 2442-2450</a></li></ul>`,
						},
						{
							heading: '9. Capsaicin and caffeine can help suppress hunger and increase feelings of fullness.',
							text: `<ul><li>Addition of capsaicin to the diet increases satiety and fullness, and tends to prevent overeating when food intake is ad libitum:<strong> </strong>Janssens PL, Hursel R, Westerterp-Plantenga MS. Capsaicin increases sensation of fullness in energy balance, and decreases desire to eat after dinner in negative energy balance. Appetite. 2014 Jun;77:44-9. doi: 10.1016/j.appet.2014.02.018. Epub 2014 Mar 12. <a href='https://pubmed.ncbi.nlm.nih.gov/24630935/'>PMID: 24630935</a>.&nbsp;</li><li>Bioactive ingredients may be helpful in reducing energy intake and might support weight loss periods by relatively sustaining satiety and suppressing hunger:<strong> </strong>Reinbach HC, Smeets A, Martinussen T, Møller P, Westerterp-Plantenga MS. Effects of capsaicin, green tea and CH-19 sweet pepper on appetite and energy intake in humans in negative and positive energy balance. Clin Nutr. 2009 Jun;28(3):260-5. doi: 10.1016/j.clnu.2009.01.010. Epub 2009 Apr 3. <a href='https://pubmed.ncbi.nlm.nih.gov/19345452/'>PMID: 19345452</a>.&nbsp;</li><li>Caffeine ingested 0.5-4 h before a meal may suppress acute energy intake: Schubert MM, Irwin C, Seay RF, Clarke HE, Allegro D, Desbrow B. Caffeine, coffee, and appetite control: a review. Int J Food Sci Nutr. 2017 Dec;68(8):901-912. doi: 10.1080/09637486.2017.1320537. Epub 2017 Apr 27. <a href='https://pubmed.ncbi.nlm.nih.gov/28446037/'>PMID: 28446037</a>.</li></ul>`,
						},
						{
							heading: '10. B vitamins help the body manage stress.',
							text: `<ul><li>Micronutrient supplementation has a beneficial effect on perceived stress, mild psychiatric symptoms, and aspects of everyday mood in apparently healthy individuals. Supplements containing high doses of B vitamins may be more effective in improving mood states: Long SJ, Benton D. Effects of vitamin and mineral supplementation on stress, mild psychiatric symptoms, and mood in nonclinical samples: a meta-analysis. Psychosom Med. 2013 Feb;75(2):144-53. doi: 10.1097/PSY.0b013e31827d5fbd. Epub 2013 Jan 29. <a href='https://pubmed.ncbi.nlm.nih.gov/23362497/'>PMID: 23362497</a>.</li></ul>`,
						},
						{
							heading: '11. L-tyrosine, L-theanine, DMAE and B vitamins may reduce feelings of stress, anxiety and depression.',
							text: `<ul><li>Oral intake of L-Theanine could cause anti-stress effects via the inhibition of cortical neuron excitation: Kimura K, Ozeki M, Juneja LR, Ohira H. L-Theanine reduces psychological and physiological stress responses. Biol Psychol. 2007 Jan;74(1):39-45. doi: 10.1016/j.biopsycho.2006.06.006. Epub 2006 Aug 22. <a href='https://pubmed.ncbi.nlm.nih.gov/16930802/'>PMID: 16930802</a>&nbsp;</li><li>L-theanine has the potential to promote mental health in people with stress-related ailments and cognitive impairments: Hidese S, Ogawa S, Ota M, Ishida I, Yasukawa Z, Ozeki M, Kunugi H. Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults: A Randomized Controlled Trial. Nutrients. 2019 Oct 3;11(10):2362. doi: 10.3390/nu11102362. <a href='https://pubmed.ncbi.nlm.nih.gov/31623400/'>PMID: 31623400</a>; &nbsp;</li><li>Tyrosine significantly decreased symptoms, adverse moods, and performance impairments in response to environmental stress:<strong> </strong>Banderet LE, Lieberman HR. Treatment with tyrosine, a neurotransmitter precursor, reduces environmental stress in humans. Brain Res Bull. 1989 Apr;22(4):759-62. doi: 10.1016/0361-9230(89)90096-8. <a href='https://pubmed.ncbi.nlm.nih.gov/2736402/'>PMID: 2736402</a></li><li>Deanol (2-dimethylaminoethanol) reduced depression, irritability and anxiety, and increased motivation-initiative: Ferris SH, Sathananthan G, Gershon S, Clark C. Senile dementia: treatment with deanol. J Am Geriatr Soc. 1977 Jun;25(6):241-4. doi: 10.1111/j.1532-5415.1977.tb00407.x. <a href='https://pubmed.ncbi.nlm.nih.gov/864168/'>PMID: 864168</a></li></ul>`,
						},
						{
							heading: '12. Caffeine increases energy by blocking the release of adenosine.',
							text: `<ul><li>Caffeine increases alertness and reduces fatigue: Smith A. Effects of caffeine on human behavior. Food Chem Toxicol. 2002 Sep;40(9):1243-55. doi: 10.1016/s0278-6915(02)00096-0. <a href='https://pubmed.ncbi.nlm.nih.gov/12204388/'>PMID: 12204388</a></li><li>Caffeine works as a nonselective blocker of adenosine receptors: Rivera-Oliver M, Díaz-Ríos M. Using caffeine and other adenosine receptor antagonists and agonists as therapeutic tools against neurodegenerative diseases: a review. Life Sci. 2014 Apr 17;101(1-2):1-9. doi: 10.1016/j.lfs.2014.01.083. Epub 2014 Feb 13.<a href='https://pubmed.ncbi.nlm.nih.gov/24530739/'> PMID: 24530739</a></li></ul>`,
						},
						{
							heading: '13. Vitamins B3, B6 and B12 help maintain energy levels and reduce tiredness and fatigue.',
							text: `<ul><li>Niacin (vitamin B3) and reduction of tiredness and fatigue: European Food Safety Authority, Oct 2010, <a href='https://doi.org/10.2903/j.efsa.2010.1757'>https://doi.org/10.2903/j.efsa.2010.1757</a>&nbsp;</li><li>Vitamin B6 and reduction of tiredness and fatigue:<strong> </strong>European Food Safety Authority, Oct 2010, &nbsp;<a href='https://doi.org/10.2903/j.efsa.2010.1759'>https://doi.org/10.2903/j.efsa.2010.1759</a>&nbsp;&nbsp;</li><li>Vitamin B12 and reduction of tiredness and fatigue:&nbsp; European Food Safety Authority, Oct 2010, <a href='https://efsa.onlinelibrary.wiley.com/doi/pdfdirect/10.2903/j.efsa.2010.1756'>https://efsa.onlinelibrary.wiley.com/doi/pdfdirect/10.2903/j.efsa.2010.1756</a></li></ul>`,
						},
						{
							heading: '14. Rhodiola rosea reduces feelings of weakness and fatigue and improves focus and. concentration.',
							text: `<ul><li>Rhodiola may be an effective treatment in subjects suffering from prolonged or chronic fatigue: Lekomtseva Y, Zhukova I, Wacker A. Rhodiola rosea in Subjects with Prolonged or Chronic Fatigue Symptoms: Results of an Open-Label Clinical Trial. Complement Med Res. 2017;24(1):46-52. doi: 10.1159/000457918. Epub 2017 Feb 17. <a href='https://pubmed.ncbi.nlm.nih.gov/28219059/'>PMID: 28219059</a>&nbsp;</li><li>Rhodiola rosea demonstrated statistically significant improvements in cognition, memory, and concentration, suggesting that rhodiola rosea can reduce general fatigue:&nbsp; Darbinyan V, Kteyan A, Panossian A, Gabrielian E, Wikman G, Wagner H. Rhodiola rosea in stress induced fatigue--a double blind cross-over study of a standardized extract SHR-5 with a repeated low-dose regimen on the mental performance of healthy physicians during night duty. Phytomedicine. 2000 Oct;7(5):365-71. doi: 10.1016/S0944-7113(00)80055-0. <a href='https://pubmed.ncbi.nlm.nih.gov/11081987/'>PMID: 11081987</a></li><li>Rhodiola rosea exerts an anti-fatigue effect that increases mental performance, particularly the ability to concentrate: Olsson EM, von Schéele B, Panossian AG. A randomised, double-blind, placebo-controlled, parallel-group study of the standardised extract shr-5 of the roots of Rhodiola rosea in the treatment of subjects with stress-related fatigue. Planta Med. 2009 Feb;75(2):105-12. doi: 10.1055/s-0028-1088346. Epub 2008 Nov 18. <a href='https://pubmed.ncbi.nlm.nih.gov/19016404/'>PMID: 19016404</a></li></ul>`,
						},
						{
							heading: '15. L-tyrosine, L-theanine and caffeine improve mood by increasing levels of dopamine, serotonin and norepinephrine.',
							text: `<ul><li>Oral administration of tyrosine can increase brain norepinephrine concentrations and activity: Gelenberg AJ, Wojcik JD, Gibson CJ, Wurtman RJ. Tyrosine for depression. J Psychiatr Res. 1982-1983;17(2):175-80. doi: 10.1016/0022-3956(82)90019-x. <a href='https://pubmed.ncbi.nlm.nih.gov/6764934/'>PMID: 6764934</a></li><li>Tyrosine significantly decreased symptoms, adverse moods, and performance impairments in response to environmental stress:<strong> </strong>Banderet LE, Lieberman HR. Treatment with tyrosine, a neurotransmitter precursor, reduces environmental stress in humans. Brain Res Bull. 1989 Apr;22(4):759-62. doi: 10.1016/0361-9230(89)90096-8. <a href='https://pubmed.ncbi.nlm.nih.gov/2736402/'>PMID: 2736402</a></li><li>L-theanine has the potential to promote mental health in people with stress-related ailments and cognitive impairments: Hidese S, Ogawa S, Ota M, Ishida I, Yasukawa Z, Ozeki M, Kunugi H. Effects of L-Theanine Administration on Stress-Related Symptoms and Cognitive Functions in Healthy Adults: A Randomized Controlled Trial. Nutrients. 2019 Oct 3;11(10):2362. doi: 10.3390/nu11102362. <a href='https://pubmed.ncbi.nlm.nih.gov/31623400/'>PMID: 31623400</a>; &nbsp;</li><li>Oral intake of L-Theanine could cause anti-stress effects via the inhibition of cortical neuron excitation: Kimura K, Ozeki M, Juneja LR, Ohira H. L-Theanine reduces psychological and physiological stress responses. Biol Psychol. 2007 Jan;74(1):39-45. doi: 10.1016/j.biopsycho.2006.06.006. Epub 2006 Aug 22. <a href='https://pubmed.ncbi.nlm.nih.gov/16930802/'>PMID: 16930802</a>&nbsp;</li><li>Neurotransmitters (e.g. dopamine, serotonin, norepinephrine and endorphin) play a role in control of happiness: Dfarhud D, Malmir M, Khanahmadi M. Happiness &amp; Health: The Biological Factors- Systematic Review Article. Iran J Public Health. 2014 Nov;43(11):1468-77. <a href='https://pubmed.ncbi.nlm.nih.gov/26060713/'>PMID: 26060713</a></li></ul>`,
						},
						{
							heading: '16. DMAE enhances mood and motivation and reduces feelings of depression, anxiety and irritability.',
							text: `<ul><li>Deanol (2-dimethylaminoethanol) reduced depression, irritability and anxiety, and increased motivation-initiative: Ferris SH, Sathananthan G, Gershon S, Clark C. Senile dementia: treatment with deanol. J Am Geriatr Soc. 1977 Jun;25(6):241-4. doi: 10.1111/j.1532-5415.1977.tb00407.x. <a href='https://pubmed.ncbi.nlm.nih.gov/864168/'>PMID: 864168</a></li></ul>`,
						},
					]"
					:text="item.text"
					background="#ffffff"
					class="border rounded-lg py-2 px-4"
					text-color="text-black"
				>
					<template #heading>
						<p class="text-start !text-base text-color my-0 mb-2">
							{{ item.heading }}
						</p>
					</template>

					<template #text>
						<div :class="`!text-base text-color pt-2`" v-html="item.text"></div>
					</template>
				</Accordion>
			</template>
		</Faqs>

		<Offer
			product-title="PHENGOLD - 1 MONTH SUPPLY"
			rated-text="Rated 4.6/5 by thousands of slimmer customers"
			product-description="PhenGold speeds up weight loss naturally, helping you lose weight quickly and effectively."
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDczMTk0NTUyMDM2MzcsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA2OTAzNjQyNTI0NjksICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA3ODE0ODYzMjg4NX1dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/47319455203637:1?channel=buy_button"
			:subscribe-price="47.99"
			:discounted-price="59.99"
			:original-price="69.99"
			:product-image="productImage"
			background="bg-[#173f88]"
			text-color="#ffffff" />
	</Content>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400..700;1,400..700&display=swap');

.content {
	--font: 'Inter', Metropolis, sans-serif;
	--color-primary: #bb8966;
	--text-color: #000000;
	--button-text-color: #ffffff;

	font-family: var(--font);
}
</style>

<style>
.text-highlight {
	color: #184089;
}

.text-color {
	color: var(--text-color);
}

.color-primary {
	color: var(--color-primary);
}

.bg-primary {
	background-color: var(--color-primary);
}

.btn-primary {
	background: var(--color-primary);
	font-weight: 700;
	color: var(--button-text-color);
}
</style>
